import React from 'react'
import WingLogo from '../images/Ideal-logo-wings.png'
function Logo() {
  return (
    <div >
      <img id= "logo" src={WingLogo} alt="Ideal Disposal Logo" />
    </div>
   
  )
}

export default Logo;